module.exports = __webpack_public_path__ + "static/media/LogoInstantPay.130ba1a5.svg";